import { ContainerModule } from 'inversify';
import { PresenterService, PresenterServiceSymbol } from './presenter-service';

export const presenterModule = new ContainerModule((bind) => {
  bind<PresenterService>(PresenterServiceSymbol).to(PresenterService);
});
